import { useContext } from 'react'
import { createPortal } from 'react-dom'

import { BirdviewHeaderActionsContainerContext } from '../../DashboardBirdview.contexts'

function BirdviewHeaderActionsPortal({ children }) {
  const container = useContext(BirdviewHeaderActionsContainerContext)

  return container ? createPortal(children, container) : null
}

export default BirdviewHeaderActionsPortal
